import React, { useEffect, useState } from 'react';
import axiosInstance from "../api";
import PdfViewer from "./pdf-viewer";
import MyDocumentViewer from "../test";
import {Spinner} from "react-bootstrap";
import {toast} from "react-toastify";

const ResumeViewer = ({ fileId }: any) => {
    const [fileUrl, setFileUrl] = useState(null);
    const [isPdf, setIsPdf] = useState(false);
    const [isDoc, setIsDoc] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchResume = async () => {
            setIsLoading(true);
            try {
                const response = await axiosInstance.get(`${fileId}`, {
                    responseType: 'arraybuffer',
                    headers: {
                        'Content-Type': 'application/pdf',
                    },
                });

                const fileType = fileId.split('.').pop().toLowerCase(); // Определение типа файла по расширению

                // @ts-ignore
                setFileUrl(URL.createObjectURL(new Blob([response.data])));
                setIsPdf(fileType === 'pdf');
                if (fileType === 'doc' || fileType === 'docx') {
                    return setIsDoc(true)
                }
                // if (fileType !== 'pdf') {
                //     const arrayBuffer = response.data;
                //     mammoth.convertToHtml({ arrayBuffer })
                //         .then((result) => {
                //             setHtmlContent(result.value);
                //         })
                //         .catch((err) => {
                //             console.error(err);
                //         });
                // }
            } catch (error) {
                console.error('Error fetching the file:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchResume();
    }, [fileId]);

    return (
      <div className="d-flex justify-content-center align-items-center min-vh-50">
          {isLoading ? (
            <div className="text-center">
                <Spinner animation="border" role="status" variant="primary" />
                <p className="mt-2">Загрузка...</p>
            </div>
          ) : isPdf ? (
            <PdfViewer fileId={fileId} />
          ) : isDoc ? (
            <MyDocumentViewer filePath={fileId} />
          ) : (
            <h3>Документ не поддерживается</h3>
          )}
      </div>
    );
};

export default ResumeViewer;

export const processPdfResponse = (data: Blob, contentDisposition?: string, shouldPrint = false) => {
    const filename = extractFilename(contentDisposition) || "full_candidate.pdf";

    const blob = new Blob([data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    if (shouldPrint) {
        // Открываем PDF в новом окне для печати
        const newWindow = window.open(url);
        if (newWindow) {
            newWindow.onload = () => {
                newWindow.print();
                URL.revokeObjectURL(url);
            };
        }
    } else {
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("Файл успешно загружен");
    }
};


export const extractFilename = (contentDisposition?: string): string | null => {
    if (!contentDisposition) return null;

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+?)(?:;|$)/);
    if (utf8Match) return decodeURIComponent(utf8Match[1]);

    const match = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/);
    return match ? match[1] : null;
};
